import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IUser } from "@sso/users/contracts";
import { useSsoUrl } from "@common/hooks/useSsoUrl";

export function useUser(uuid: string) {
  const { request } = useSsoUrl();
  return useQuery(`user:${uuid}`, async () => {
    const { users } = await request(
      gql`
        query ($uuid: ID) {
          users(filter: { uuid: $uuid }) {
            data {
              id
              uuid
              email
              mobileNumber
              status
              name
              identity
              createdAt
              passwordChangedAt
              profiles {
                role
                identity
              }
              revokedUuids
            }
          }
        }
      `,
      { uuid }
    );
    const allUsers = users.data.map((data: IUser) => data) as IUser[];

    return allUsers.shift();
  });
}
